import "./LoginOtpVerification.scss";
import { LoginLayout } from "../../../layouts";
import primaryComponents from "../../../components/primaryComponents";
import secondaryComponents from "../../../components/secondaryComponents";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import LoginVerificationLogic from "./LoginOtpVerificationLogic";

const LoginOtpVerification = () => {
  const {
    handleOTPInputs,
    handleResendOtp,
    countDown,
    otp,
    isVerifing,
    sentTo,
    phone_number,
    // email,
  } = LoginVerificationLogic();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Login - Verification"
      description="Log in to your lumi merchant account"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <LoginLayout>
            <div className="login-verification-page">
              <div className="login-verification-page__container">
                <h3 className="purple--text text-center">Verification</h3>
                <p className="text-center">
                  Enter the 4-digit code sent to{" "}
                  <span className="purple--text mt-2 font-weight-semibold">
                    {sentTo}
                  </span>
                </p>

                <form className="verification__form">
                  {!isVerifing ? (
                    <primaryComponents.OtpInputField
                      onChange={handleOTPInputs}
                      numOfInputs={4}
                      value={otp}
                    />
                  ) : (
                    <h4 className="purple--text font-weight-normal">
                      Verifying...
                    </h4>
                  )}
                </form>

                <div className="text-center mb-4">
                  {countDown === 0 ? (
                    <div>
                      <span>
                        <Link
                          className="cursor-pointer purple--text"
                          onClick={() => handleResendOtp()}
                        >
                          Resend
                        </Link>{" "}
                        <span className="dark--text">to email</span>
                      </span>
                      <br />
                      {phone_number ? (
                        <span>
                          <Link
                            className="cursor-pointer purple--text"
                            onClick={() => handleResendOtp("sms")}
                          >
                            Resend{" "}
                          </Link>
                          <span className="dark--text">to phone number</span>
                        </span>
                      ) : null}
                    </div>
                  ) : (
                    <p>
                      Didn&apos;t get code? Retry in{" "}
                      <span className="dark--text">{countDown}</span>
                    </p>
                  )}
                </div>

                <p>
                  <Link
                    className="font-weight-semibold"
                    to="/login"
                    style={{ textDecoration: "underline" }}
                  >
                    Return to Login
                  </Link>
                </p>
              </div>
            </div>
          </LoginLayout>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default LoginOtpVerification;
